import { useEffect, useRef } from "react";

export const useClickOutside = (
  handler: () => void,
  specificTargetHandler?: (arg0: any) => void
) => {
  const domNode = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const maybeHandler = (event: { target: any }) => {
      if (domNode.current && !domNode.current.contains(event.target)) {
        handler();

        if (specificTargetHandler) {
          specificTargetHandler(event.target);
        }
      }
    };

    document.addEventListener("mousedown", maybeHandler);

    return () => {
      document.removeEventListener("mousedown", maybeHandler);
    };
  });

  return domNode;
};
